
import Vue from 'vue';

import frac2Percent from '@/mixins/fractionalToPercent';
import { ColumnDefGroup, GroupRowData, } from '@/pages/search/results/table/table-layout';
import IRow from '@/pages/search/results/table/IRow.vue';

export default Vue.component('GroupRow', IRow.extend({
	props: {
		row: Object as () => GroupRowData,
	},
	methods: {
		frac2Percent,
		barStyle(col: ColumnDefGroup): Record<string, string> {
			// if (!col.barField || this.row[col.barField] == null) return { width: '0', minWidth: '0', maxWidth: '0', padding: '0', color: 'black', textShadow: 'none', marginLeft: '6px', fontWeight: 'bold', overflow: 'visible', opacity: '0.8' }
			if (!col.barField || this.row[col.barField] == null) return { width: '100%', opacity: '0.8' }
			return { minWidth: this.frac2Percent(this.row[col.barField]! / this.maxima[col.barField])}
		},
		valueForCell(col: ColumnDefGroup): string {
			const v = this.row[col.labelField];
			if (v == null) return this.$t('results.groupBy.groupNameWithoutValue').toString();
			if (col.showAsPercentage && typeof v === 'number') return this.frac2Percent(v);
			return v.toLocaleString();
		}
	},
}));
